import React from 'react';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import { HiChevronDown } from 'react-icons/hi';
import classnames from 'classnames';
import useMediaQuery from '../hooks/useMediaQuery';

/**
 * En pantallas táctiles el <select> nativo de iOS/Android se reabre al cancelar sin elegir.
 * Con pointer: coarse usamos Listbox (Headless UI); en ratón, <select> nativo.
 */
export default function CoarseSafeSelect({
  id,
  value,
  onChange,
  options,
  disabled = false,
  className = '',
}) {
  const isCoarse = useMediaQuery('(pointer: coarse)');
  const selected = options.find((o) => o.value === value);

  if (isCoarse) {
    return (
      <div className={classnames('relative min-w-0', className.includes('flex-1') && 'flex-1')}>
        <Listbox value={value} onChange={onChange} disabled={disabled}>
          <ListboxButton
            id={id}
            className={classnames(
              className,
              'flex items-center justify-between gap-2 text-left disabled:opacity-50 disabled:cursor-not-allowed'
            )}
          >
            <span className="truncate">{selected?.label ?? '—'}</span>
            <HiChevronDown className="h-4 w-4 shrink-0 text-gray-500" aria-hidden />
          </ListboxButton>
          <ListboxOptions
            anchor="bottom start"
            className="z-50 mt-1 max-h-60 min-w-[var(--button-width)] overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none"
          >
            {options.map((opt) => (
              <ListboxOption
                key={opt.value}
                value={opt.value}
                className={({ focus, selected: isSelected }) =>
                  classnames(
                    'cursor-pointer px-3 py-2',
                    focus && 'bg-emerald-50',
                    isSelected && 'font-medium text-emerald-700'
                  )
                }
              >
                {opt.label}
              </ListboxOption>
            ))}
          </ListboxOptions>
        </Listbox>
      </div>
    );
  }

  return (
    <select
      id={id}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
